import { jsx as _jsx } from "react/jsx-runtime";
import BaseLegalString from '@telus/hs-react-legals/LegalString';
import { Footnote } from '@telus-uds/components-web';
/**
 * A component that renders legal superscripts whenever the indexed or non-indexed legal
 * keys are found in the content.
 *
 * Here are some examples of an indexed and non-indexed key.
 * - `${LEGAL.shs-mobility-legal}`
 * - `${NONINDEX_LEGAL.shs-mobility-legal}`
 *
 * All props will be forwarded to the inner footnote link component`.
 */
const LegalString = (props) => {
    return _jsx(BaseLegalString, Object.assign({}, props, { footnoteLinkComponent: Footnote.Link }));
};
LegalString.displayName = 'LegalString';
export default LegalString;
